import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import { search } from '~/state/ducks/organizations/operations';

import Search from '~/views/common/Search';
import Heading from '~/views/common/Heading';


const filters = ['portals', 'archived', 'deleted'];


const Portals = () => (
    <Fragment>
        <Helmet title="Portals" />

        <Heading
            header="Portals"
            subheader="Search"
            iconName="university"
        />

        <Search
            placeholder="Name / ID"
            onSubmit={search}
            filters={filters}
            systemPortalList={false}
        />
    </Fragment>
);

export default Portals;
